import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {CurrentUserEffects} from './current-user.effects';
import * as fromCurrentUser from './current-user.reducer';
import {currentUserFeatureKey} from './current-user.selectors';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(currentUserFeatureKey, fromCurrentUser.reducer),
    EffectsModule.forFeature([CurrentUserEffects]),
  ],
})
export class CurrentUserModule {}
